import HttpService from './commons/HttpService';

const AppointmentService = {
  sync(dataList, installationId) {
    return HttpService.post('/appointments/sync', dataList, { params: { installationId } });
  },
  save(appointment) {
    if (appointment.id && appointment.id > 0) {
      return this.update(appointment);
    }
    return this.create(appointment);
  },
  create(appointment) {
    return HttpService.post('/appointments', appointment);
  },
  createAll(appointment) {
    return HttpService.post('/appointments/all', appointment);
  },
  update(appointment) {
    return HttpService.put(`/appointments/${appointment.id}`, appointment);
  },
  // repetition
  updateRepetition(appointment) {
    return HttpService.put(`/appointments/${appointment.id}/repetition`, appointment);
  },
  deleteRepetition(appointment) {
    return HttpService.delete(`/appointments/${appointment.id}/repetition`);
  },
  // repetition
  delete(appointment) {
    return HttpService.delete(`/appointments/${appointment.id}`);
  },
  cancel(appointment) {
    return HttpService.delete(`/appointments/cancel/${appointment.id}`);
  },
  cancelWithComments(appointmentId, comments) {
    return HttpService.put(`/appointments/cancelWithComments/${appointmentId}`, { comments });
  },
  getById(id) {
    return HttpService.get(`/appointments/${id}`);
  },
  getAllByDate(date) {
    return HttpService.get('/appointments', { params: { date } });
  },
  getOccupancyStatus(startDate, endDate) {
    return HttpService.get('/appointments/occupancyStatus', { params: { startDate, endDate } });
  },
  getAllBetweenGroupedByDate(startDate, endDate) {
    return HttpService.get('/appointments/groupedByDate', { params: { startDate, endDate } });
  },
  getAllByDateGroupedByUser(date) {
    return HttpService.get('/appointments/groupedByEmployee', { params: { date } });
  },
  getGroupedByEmployeesByDateAndEmployeeIdsOrRoomIds(date, employeeIds, roomIds) {
    return HttpService.get('/appointments/groupedByEmployeesOrRooms', {
      params: { date, employeeIds: employeeIds.join(','), roomIds: roomIds.join(',') },
    });
  },
  getAllByDateForCurrentUser(date) {
    return HttpService.get('/appointments/groupedByEmployee/currentUser', { params: { date } });
  },
  searchForUser(customerName, startDate, endDate) {
    return HttpService.get('/appointments/search', { params: { customerName, startDate, endDate } });
  },
  searchForCompany(customerName, startDate, endDate) {
    return HttpService.get('/appointments/searchForCompany', {
      params: { customerName, startDate, endDate },
    });
  },
  findByDateRange({ startDate, endDate, employeeId, fetchComandas }) {
    return HttpService.get('/appointments/byDateRange', {
      params: { startDate, endDate, employeeId, fetchComandas },
    });
  },
  findAppsByDateRange({ startDate, endDate, employeeId, customerId, serviceId }) {
    return HttpService.get('/appointments/appsByDateRange', {
      params: { startDate, endDate, employeeId, customerId, serviceId },
    });
  },
  findAppsByDateRangeWithAudit({ startDate, endDate, employeeId, customerId, onlyDeleted }) {
    return HttpService.get('/appointments/appsByDateRangeWithAudit', {
      params: { startDate, endDate, employeeId, customerId, onlyDeleted },
    });
  },
  findAppsByCreatedAtDateRangeWithAudit({ startDate, endDate, employeeId }) {
    return HttpService.get('/appointments/appsByCreatedAtDateRangeWithAudit', {
      params: { startDate, endDate, employeeId },
    });
  },

  findWeeklyAgenda({ startOfWeek, endOfWeek, employeeId, fetchComandas }) {
    return HttpService.get('/appointments/weeklyAgenda', {
      params: { startOfWeek, endOfWeek, employeeId, fetchComandas },
    });
  },
  findAllForCurrentUser() {
    return HttpService.get('/appointments');
  },
  findMostRecentDistinctServices(employeeId) {
    return HttpService.get('/appointments/mostRecentDistinctServices', { params: { employeeId } });
  },
  findNumberOfAppointmentsForPeriod(startDate, endDate) {
    return HttpService.get('/appointments/mostRecentDistinctServices', { params: { startDate, endDate } });
  },
  exists({ employeeId, date, startTime, exceptForId }) {
    return HttpService.get('/appointments/exists', { params: { employeeId, date, startTime, exceptForId } });
  },
  findAllNonPaid(customerId) {
    return HttpService.get('/appointments/nonPaids', { params: { customerId } });
  },
  addNonPaid(appointment) {
    return HttpService.post(`/appointments/nonPaids/${appointment.id}`);
  },
  removeNonPaid(appointment) {
    return HttpService.delete(`/appointments/nonPaids/${appointment.id}`);
  },
  createPayment(payment) {
    return HttpService.post(`/appointments/${payment.appointmentId}/payments`, payment);
  },
  deletePayment(payment) {
    return HttpService.delete(`/appointments/${payment.appointmentId}/payments/${payment.id}`);
  },
  getPayments(appointmentId) {
    return HttpService.get(`/appointments/${appointmentId}/payments`, {
      params: { appointmentId },
    });
  },
  getPaymentSummary(appointmentId) {
    return HttpService.get(`/appointments/${appointmentId}/paymentSummary`, {
      params: { appointmentId },
    });
  },
  generateReceipt(appointmentId) {
    return HttpService.post(`/appointments/${appointmentId}/receiptFile`, null, {
      responseType: 'arraybuffer',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      const fileName = 'recibo_atendimento_' + new Date().getTime() + '.pdf';
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    });
  },

  applyDiscount(appointmentId, form) {
    return HttpService.put(`/appointments/${appointmentId}/discount`, form);
  },

  updateComments(appointmentId, form) {
    return HttpService.put(`/appointments/${appointmentId}/comments`, form);
  },

  updateTag(appointmentId, form) {
    return HttpService.put(`/appointments/${appointmentId}/tag`, form);
  },

  updatePaymentMethod(appointmentId, form) {
    return HttpService.put(`/appointments/${appointmentId}/paymentMethod`, form);
  },

  getByCustomerAndTag({ startDate, endDate, customerId, appointmentTag }) {
    return HttpService.get('/appointments/byCustomerAndTag', {
      params: { startDate, endDate, customerId, appointmentTag },
    });
  },
  getCompanyPerformance({ startDate, endDate }) {
    return HttpService.get('/appointments/companyPerformance', {
      params: { startDate, endDate },
    });
  },
  getEmployeePerformance({ startDate, endDate, employeeId }) {
    return HttpService.get('/appointments/employeePerformance', {
      params: { startDate, endDate, employeeId },
    });
  },
};
export default AppointmentService;
